import React, { useState } from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { BiCollapse, BiCollapseAlt } from 'react-icons/bi';
import { FiDownload } from 'react-icons/fi';
import * as S from '../styles';

interface TeacherNotesTabProps {
    pdfUrl?: string;
    isActive?: boolean;
    setFullScreen?: () => void;
    closeFullScreen?: () => void;
    isTeacher?: boolean;
}

const TeacherNotesTab: React.FC<TeacherNotesTabProps> = ({
    pdfUrl,
    isTeacher = false,
    isActive,
    setFullScreen,
    closeFullScreen,
}) => {
    const [pdfLoading, setPdfLoading] = useState(false);

    if (!pdfUrl) {
        return <div>No Teacher Notes available</div>;
    }

    const handleIconClick = () => {
        if (isActive) {
            closeFullScreen?.();
        } else {
            setFullScreen?.();
        }
    };

    const handleDownload = () => {
        setPdfLoading(true);

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = 'TeacherNotes.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            setPdfLoading(false);
        }, 1000);
    };

    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start', marginRight: 30 }}>
                <S.Icon isTeacher={isTeacher} onClick={handleIconClick} style={{ marginTop: 10 }}>
                    {isActive ? <BiCollapseAlt /> : <BiCollapse />}
                </S.Icon>
            </div>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    minHeight: '400px',
                }}
            >
                <button
                    onClick={handleDownload}
                    style={{
                        padding: '10px 20px',
                        fontSize: '16px',
                        border: 'none',
                        backgroundColor: '#3f78e0',
                        color: '#fff',
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginTop: '-200px',
                    }}
                >
                    <FiDownload style={{ fontSize: 18 }} />
                    Download Teacher Notes
                    {pdfLoading && (
                        <Spin
                            indicator={<LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />}
                        />
                    )}
                </button>
            </div>
        </div>
    );
};

export default TeacherNotesTab;
